/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatchOperationsEvent
 */
export interface MatchOperationsEvent {
    /**
     * 
     * @type {string}
     * @memberof MatchOperationsEvent
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchOperationsEvent
     */
    matchId?: string;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationsEvent
     */
    serverSequence?: number;
    /**
     * 
     * @type {Date}
     * @memberof MatchOperationsEvent
     */
    serverTimestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof MatchOperationsEvent
     */
    clientEventId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatchOperationsEvent
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationsEvent
     */
    period?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationsEvent
     */
    elapsedMs?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MatchOperationsEvent
     */
    teamId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatchOperationsEvent
     */
    teamSide?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatchOperationsEvent
     */
    playerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatchOperationsEvent
     */
    createdBy?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatchOperationsEvent
     */
    note?: string | null;
}

/**
 * Check if a given object implements the MatchOperationsEvent interface.
 */
export function instanceOfMatchOperationsEvent(value: object): value is MatchOperationsEvent {
    return true;
}

export function MatchOperationsEventFromJSON(json: any): MatchOperationsEvent {
    return MatchOperationsEventFromJSONTyped(json, false);
}

export function MatchOperationsEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchOperationsEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'matchId': json['matchId'] == null ? undefined : json['matchId'],
        'serverSequence': json['serverSequence'] == null ? undefined : json['serverSequence'],
        'serverTimestamp': json['serverTimestamp'] == null ? undefined : (new Date(json['serverTimestamp'])),
        'clientEventId': json['clientEventId'] == null ? undefined : json['clientEventId'],
        'type': json['type'] == null ? undefined : json['type'],
        'period': json['period'] == null ? undefined : json['period'],
        'elapsedMs': json['elapsedMs'] == null ? undefined : json['elapsedMs'],
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'teamSide': json['teamSide'] == null ? undefined : json['teamSide'],
        'playerId': json['playerId'] == null ? undefined : json['playerId'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function MatchOperationsEventToJSON(json: any): MatchOperationsEvent {
    return MatchOperationsEventToJSONTyped(json, false);
}

export function MatchOperationsEventToJSONTyped(value?: MatchOperationsEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'matchId': value['matchId'],
        'serverSequence': value['serverSequence'],
        'serverTimestamp': value['serverTimestamp'] == null ? value['serverTimestamp'] : value['serverTimestamp'].toISOString(),
        'clientEventId': value['clientEventId'],
        'type': value['type'],
        'period': value['period'],
        'elapsedMs': value['elapsedMs'],
        'teamId': value['teamId'],
        'teamSide': value['teamSide'],
        'playerId': value['playerId'],
        'createdBy': value['createdBy'],
        'note': value['note'],
    };
}

